// ===========================================================================
// LOCAL DEBUG ONLY.
// Keeps the green zone of good launches on screen the whole time, not just with
// the target circle hint, and puts up a panel to tune it live: how much its edges
// are smoothed, how strong it is at Earth and how far along it fades out.
//
// The zone is worked out once from every launch that would meet Mars (see
// Game.buildGoodZone), which is the slow part. This keeps the launches it was
// given, so moving a slider only redraws the outline from them.
//
// Self-activating: js/index.js picks every *Debug.js up on its own, so just load
// the page with ?zoneDebug. It reads the game off window.app.game.
// ===========================================================================

const SLIDERS = [
  {label: "Smoothing", key: "goodZoneSmoothing", min: 0, max: 0.5, step: 0.005},
  {label: "Fade at", key: "goodZoneFadeAt", min: 0.05, max: 1, step: 0.01},
  {label: "Strength", key: "goodZoneStrength", min: 0, max: 1, step: 0.01},
];

function buildPanel(redraw, solarSystem) {
  const panel = document.createElement("div");
  panel.style.cssText =
    "position:fixed;bottom:12px;right:12px;z-index:99999;background:rgba(0,0,0,.8);" +
    "color:#fff;font:12px/1.4 monospace;padding:12px 14px;border-radius:8px;width:260px";

  const heading = document.createElement("div");
  heading.style.cssText = "font-weight:bold;margin-bottom:6px";
  heading.textContent = "Good zone";
  panel.append(heading);

  SLIDERS.forEach(({label, key, min, max, step}) => {
    const title = document.createElement("div");
    title.style.cssText = "margin:6px 0 4px";
    title.textContent = label;

    const row = document.createElement("label");
    row.style.cssText = "display:flex;align-items:center;gap:8px";
    const slider = document.createElement("input");
    slider.type = "range";
    slider.min = min;
    slider.max = max;
    slider.step = step;
    slider.value = solarSystem[key];
    slider.style.flex = "1";
    const val = document.createElement("span");
    val.style.cssText = "flex:0 0 44px;text-align:right";
    val.textContent = Number(slider.value).toFixed(3);

    slider.addEventListener("input", () => {
      const v = parseFloat(slider.value);
      val.textContent = v.toFixed(3);
      solarSystem[key] = v;
      redraw();
    });

    row.append(slider, val);
    panel.append(title, row);
  });

  document.body.appendChild(panel);
}

// Force the zone on whenever it is drawn or the hint would hide it, which covers
// a restart rebuilding the whole trajectory layer.
function keepZoneShown(solarSystem) {
  const show = () => {
    document.querySelector("#trajectory-layer .trajectory-good-zone")?.classList.add("is-active");
  };

  const drawGoodZone = solarSystem.drawGoodZone.bind(solarSystem);
  solarSystem.drawGoodZone = () => {
    drawGoodZone();
    show();
  };

  const showDestination = solarSystem.showDestination.bind(solarSystem);
  solarSystem.showDestination = (...args) => {
    showDestination(...args);
    show();
  };

  const setTargetRingRevealed = solarSystem.setTargetRingRevealed.bind(solarSystem);
  solarSystem.setTargetRingRevealed = (on) => {
    setTargetRingRevealed(on);
    show();
  };

  show();
}

function enable(game) {
  const solarSystem = game.solarSystem;

  // Hold on to the launches every time the zone is worked out, so a slider can
  // redraw the outline without walking the whole drag again.
  let last = null;
  const setGoodZone = solarSystem.setGoodZone.bind(solarSystem);
  solarSystem.setGoodZone = (geos, travel) => {
    last = {geos, travel};
    setGoodZone(geos, travel);
  };

  keepZoneShown(solarSystem);

  // Already worked out before this attached: do it again to catch the launches.
  if (game.goodZoneBuilt) game.buildGoodZone();

  buildPanel(() => {
    if (last) setGoodZone(last.geos, last.travel);
  }, solarSystem);

  // eslint-disable-next-line no-console
  console.log("zone debug on: good zone always shown, tune it from the panel");
}

function init() {
  if (!new URLSearchParams(window.location.search).has("zoneDebug")) return;
  const tryAttach = () => {
    const game = window.app && window.app.game;
    if (!game || !game.solarSystem) return setTimeout(tryAttach, 200);
    enable(game);
  };
  tryAttach();
}

init();
